<template>
  <header>
    <img :src="image" class="navbar-brand-img w-100" alt="Sidebar logo" />
  </header>
</template>
<script>
export default {
  name: "Header",
  props: {
    image: {
      type: String,
      default: "",
    },
    title: {
      type: [String, Object],
      default: "",
      text: String,
      variant: {
        validator(value) {
          return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
        },
      },
      class: {
        type: String,
        default: "",
      },
    },
    description: {
      type: [String, Object],
      default: "",
      text: String,
      class: String,
    },
    mask: {
      type: String,
      default: "mask bg-gradient-success opacity-4",
    },
    center: {
      type: Boolean,
      default: false,
    },
    minHeight: {
      type: String,
      default: " min-vh-75",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
